import React, { memo } from 'react';
import { useLocale } from '@redlink/assets/locale';
import { BodyBlockContainer } from './bodyBlockContainer';
import { useMoneyMask } from '@redlink/core';
import { ReportSummaryList } from './reportSummaryList';
import { TopTenLinkList } from './topTenLinkList';
import { BlockContainer } from './blockContainer';
import { Space, LoadingContainer } from '@redlink/components/atoms';
import { useQuery, getShopSummaryQuery } from '@redlink/services';

export const ShopBlock = memo(() => {
  const { dictionary } = useLocale();
  const { getValue } = useMoneyMask();

  const {
    loading: getSummaryLoading,
    data: {
      ShopSummary: {
        count = 0,
        countChange = 0,
        activeCount = 0,
        avgUserLinks = 0,
        categoryCount = 0,
        avgUserCategories = 0,
        avgCategoryPosts = 0,
        orderCount = 0,
        orderCountChange = 0,
        avgUserOrders = 0,
        avgProductOrders = 0,
        topTen = [],
      } = {},
    },
  } = useQuery(getShopSummaryQuery);

  const data = [
    {
      title: dictionary.productCount,
      value: count,
      change: countChange,
      valueFormatter: (value) => getValue(value),
    },
    {
      title: dictionary.activeProductCount,
      value: activeCount,
    },
    {
      title: dictionary.ordersCount,
      value: orderCount,
      change: orderCountChange,
      valueFormatter: (value) => getValue(value),
    },
    {
      title: dictionary.avgOrdersPerShop,
      value: avgUserOrders,
    },
    {
      title: dictionary.avgProductsPerUser,
      value: avgUserLinks,
    },
    {
      title: dictionary.avgOrdersPerProduct,
      value: avgProductOrders,
    },
    {
      title: dictionary.categoryCount,
      value: categoryCount,
      valueFormatter: (value) => getValue(value),
    },
    {
      title: dictionary.avgCategoryPerShop,
      value: avgUserCategories,
    },
    {
      title: dictionary.avgProductPerCategory,
      value: avgCategoryPosts,
    },
  ];

  return (
    <BlockContainer title={dictionary.shopReport}>
      <Space />
      <LoadingContainer isBusy={getSummaryLoading}>
        <BodyBlockContainer>
          <ReportSummaryList {...{ data }} />
          <TopTenLinkList data={topTen} />
        </BodyBlockContainer>
      </LoadingContainer>
    </BlockContainer>
  );
});
